// extracted by mini-css-extract-plugin
export default {"tag":"MGTag_tag__f+NGY","label":"MGTag_label__AZ1Ka","close":"MGTag_close__aAn1c"};